import React from 'react';

import {ObjectsSection} from './components/ObjectsSection';

interface ModelsSectionProps {
  entityName: string;
  projectName: string;
}

export const ModelsSection: React.FC<ModelsSectionProps> = ({
  entityName,
  projectName,
}) => {
  return (
    <ObjectsSection
      entityName={entityName}
      projectName={projectName}
      objectClass="Model"
      title="Models"
      viewAllPath="models"
      emptyMessage="No models yet"
      emptySubtitle="Models you create will appear here"
      emptyIcon="model"
      emptyIconColor="text-purple-500"
      emptyIconBgGradient="from-purple-50 to-purple-100"
    />
  );
};
